import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useCountdown } from '../contexts/CountdownContext';
type Props = {
  size?: 'sm' | 'lg';
  className?: string;
};
function Digit({
  value,
  size
}: {
  value: string;
  size: 'sm' | 'lg';
}) {
  const height = size === 'lg' ? 'h-[52px] sm:h-[60px]' : 'h-[22px]';
  const text = size === 'lg' ? 'text-[42px] sm:text-[48px]' : 'text-[17px]';
  return <span className={`relative inline-block overflow-hidden ${height} ${text} font-mono font-bold leading-none tabular-nums`} style={{
    width: size === 'lg' ? '0.66em' : '0.62em'
  }} data-id="element-44" data-mp="1kbyccosbm1vt">
      <AnimatePresence initial={false} mode="popLayout" data-id="element-45" data-mp="1abxs90mmnhqk">
        <motion.span key={value} initial={{
        y: '-90%',
        opacity: 0
      }} animate={{
        y: '0%',
        opacity: 1
      }} exit={{
        y: '90%',
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="absolute inset-0 flex items-center justify-center" data-id="element-46" data-mp="1aek9jrzblblz">
          {value}
        </motion.span>
      </AnimatePresence>
    </span>;
}
export function CountdownTimer({
  size = 'sm',
  className = ''
}: Props) {
  const {
    hours,
    minutes,
    seconds,
    isExpired
  } = useCountdown();
  const groups = [hours, minutes, seconds];
  return <motion.div animate={isExpired ? {
    opacity: 1
  } : {
    opacity: [1, 0.78, 1]
  }} transition={{
    duration: 1,
    repeat: isExpired ? 0 : Infinity,
    ease: 'linear'
  }} className={`flex items-center text-gold ${className}`} role="timer" aria-live="off" aria-label={`Oferta termina en ${hours} horas ${minutes} minutos ${seconds} segundos`} data-id="element-47" data-mp="17129u0ymnter">
      {groups.map((group, gi) => <React.Fragment key={gi} data-id="element-48" data-mp="1q0g5qofx3e7w" data-mpi={gi}>
          {gi > 0 && <span className={`px-[0.1em] font-mono font-bold leading-none ${size === 'lg' ? 'text-[38px] sm:text-[44px]' : 'text-[16px]'}`} aria-hidden="true" data-id="element-49" data-mp="1pz53it24eeiw">
              :
            </span>}
          <Digit value={group[0]} size={size} data-id="element-50" data-mp="2ihiv4awv549j" />
          <Digit value={group[1]} size={size} data-id="element-51" data-mp="2scr4teuge8mt" />
        </React.Fragment>)}
    </motion.div>;
}